/**
 * Centralized function name constants.
 * Maps to backend handler function_name values (see raw_output_keys.py).
 * Change here if the backend renames a function — all frontend detection updates automatically.
 */
export const CHAT_FUNCTIONS = {
  ORGANIZATION_EVENTS: 'organization_events',
  ORGANIZATION_EVENT_PROACTIVE: 'organization_event_proactive',
  CALENDAR_EVENTS: 'view_calendar_events',
  VIEW_BOOKINGS: 'view_bookings',
  CREATE_BOOKING: 'create_booking',
  CANCEL_BOOKING: 'cancel_booking',
  UPDATE_BOOKING: 'update_booking',
  COMMUNITY_ANNOUNCEMENT: 'community_announcement',
};
